import detail from "./detail";
import marker from "./marker";
import preview from "./preview";
import viewer from "./viewer";

export default `
${detail}
${viewer}
${marker}
${preview}
`;
